export var AgentType;
(function (AgentType) {
    AgentType["Builder"] = "builder";
    AgentType["Regular"] = "regular";
})(AgentType || (AgentType = {}));
//# sourceMappingURL=agent-type.const.js.map